var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "closebtn",
    transform: "translate(-880 -326)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_936",
    "data-name": "Ellipse 936",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(880 326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Cross_2335558",
    transform: "translate(892 338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7148",
    "data-name": "Path 7148",
    d: "M54.446,991.755l-6.988,6.988-6.988-6.988-1.075,1.075,6.989,6.989-6.989,6.989,1.075,1.075,6.988-6.989,6.988,6.989,1.075-1.075-6.989-6.989,6.989-6.989Z",
    transform: "translate(-39.393 -991.755)",
    fill: "#052f35 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.eecca9d3.svg";
export { ForwardRef as ReactComponent };